<template>
  <header class="app-header">
    <img class="gob-band-icon" src="@/assets/images/gob-band.svg" alt="Gob Band">
    <div class="app-header__content">
      <div class="app-header__content-left">
        <router-link to="/" tag="h1" class="app-header__title">
          <i class="far fa-file-alt" /> Administración de Usuarios Receta
        </router-link>
        <div class="app-header__date">
          <app-date-time />
        </div>
      </div>
      <div class="app-header__content-right">
        <div class = "row">
            <div class = "col-md-8">
              <auth-user-info :user="user" />
            </div>
             <div class = "col-md-4 pt-4">
            <router-link tag="button" to="/auth/logout" class="btn btn-danger">
              <i class="fas fa-sign-out-alt" /> Cerrar sesión
            </router-link>
            </div>
          </div>
      </div>
    </div>
  </header>
</template>

<script>
import AuthUserInfo from '../components/auth/AuthUserInfo';
import AppDateTime from '@/components/AppDateTime';

export default {
  name: 'AppHeader',
  components: {
    AppDateTime,
    AuthUserInfo
  },
  computed: {
    user() {
      return this.$store.getters.user;
    }
  }
};
</script>

<style lang="scss">
.app-header {
  position: relative;
  padding: $--spacing-6;

  &__content-left {
    .far {
      width: 22px;
      text-align: center;
      font-size: $--font-size-sm;
    }
  }

  &__title {
    font-family: gobcl, 'Helvetica Neue', Arial, sans-serif;
    font-size: $--font-size-md;
    font-weight: $--font-weight-regular;
    margin-bottom: 0;
  }

  &__date {
    font-size: $--font-size-sm;
  }

  &__content {
    display: flex;
    justify-content: space-between;
  }

  &__content-right {
    display: flex;
    flex-direction: row;
    align-items: center;

    .auth-user-info {
      margin-right: $--spacing-3;
    }
  }

  .gob-band-icon {
    position: absolute;
    top: 0;
    left: $--spacing-6;
  }
}
</style>
